module.exports = __webpack_public_path__ + "media/images/story/story-og-image-42476a6bdbff127652823aa5fd6cee55.png";